import React from 'react'

const Select = ({ items, selected, onChange }) => (
  <select onChange={onChange} value={selected}>
    {items.map(({ value, name }) => (
      <option key={value} value={value}>
        {name}
      </option>
    ))}
  </select>
)

export default Select



// WEBPACK FOOTER //
// ./src/components/UI/Form/Select.jsx